import store from '@/redux/store'

const getAppRouteBasename = (_settings) => {
	/* If this func is called before redux state init */
	const settings = _settings || store.getState().settings

	const { custom_domainYN, url_root_path } = settings || {}

	if (!custom_domainYN && !url_root_path) {
		throw new Error('Invalid "settings -> url_root_path" value')
	}

	return custom_domainYN ? '/' : url_root_path
}

export default getAppRouteBasename
